import httpService from "../../../../services/httpService";

export interface OpportunityMetrics {
  company_id?: string | null;
  opportunity_id?: string | null;
  total_applications: number;
  stage_counts: Record<string, number>;
  rejected_count: number;
  hired_count: number;
  total_scored: number;
  avg_match_score?: number | null;
  source_counts: Record<string, number>;
  monthly_applications: Record<string, number>;
  updated_at?: string | null;
}

export interface BaseMetricsAgg {
  total_opportunities: number;
  open_opportunities: number;
  draft_opportunities: number;
  total_applications: number;
  total_hires: number;
  total_rejected: number;
  total_scored: number;
  avg_match_score?: number | null;
  source_counts: Record<string, number>;
  stage_counts: Record<string, number>;
  monthly_applications: Record<string, number>;
  action_required?: Record<string, number>;
  skill_counts?: Record<string, number>;
  offer_outcome?: {
    offered: number;
    accepted: number;
    declined: number;
    not_answered: number;
  };
}

export interface CompanyJobMetrics extends BaseMetricsAgg {
  company_id?: string | null;
  per_opportunity: OpportunityMetrics[];
  internal_metrics?: BaseMetricsAgg | null;
  organizations_metrics?: Record<string, BaseMetricsAgg>;
  updated_at?: string | null;
}

class JobDashboardClient {
  private basePath = "/job_dashboard";

  async getMetrics(jobId?: string, organizationId?: string): Promise<any> {
    const params = new URLSearchParams();
    if (jobId) params.append("job_id", jobId);
    if (organizationId) params.append("organization_id", organizationId);
    const queryString = params.toString();
    const url = queryString ? `${this.basePath}?${queryString}` : this.basePath;
    const response = await httpService.get<any>(url);
    return response.data;
  }

  async getDashboardDetails(): Promise<any> {
    const response = await httpService.get<any>(`${this.basePath}/details`);
    return response.data;
  }
}

const client = new JobDashboardClient();
export default client;
